<template>
  <div>
    <Header>Journal<ComingSoonBadge /></Header>
    <p class="emphasize">
      Keep track of things that went well as well as those that didn't.
    </p>
    <p class="emphasize mb-3">
      Do not repeat the same mistake twice, and stay motivated when things go downhill.
    </p>
    <img class="blur-2 semi-transparent" :src="`/images/coming-soon/${theme}/notes.jpg`" />
  </div>
</template>
<script>
import ComingSoonBadge from './Badge'

export default {
  components: {
    ComingSoonBadge,
  },
  computed: {
    theme () {
      return this.$store.state.theme
    }
  }
}
</script>
